(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFormGenerator', fbFormGeneratorDirective);

    const defaultTemplateUrl = 'common/libraries/formBuilder/formGenerator';

    function fbFormGeneratorDirective($timeout) {
        return {
            restrict: 'EA',
            scope: {
                fbData: '=',
                fbModel: "=?",
                hideButtons: '=?',
                getModel: '=?',
                submit:'&?',
                setModel: '=?',
            },
            controller: fbFormGeneratorDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope) {
                $timeout(function() {
                    scope.vm.init();
                })
            }
        };
    }

    function fbFormGeneratorDirectiveCtrl(FormBuilderService, $scope, lodash, FormBuilderHelper, $timeout, $element, $compile, $templateCache) {
        // console.log('form generator controller');
        var vm = this;

        this.$onInit = function() {
            vm.loaded = false;

            const templateUrl = lodash.get(vm.fbData, 'settings.template_url', defaultTemplateUrl);
            const template = $templateCache.get(templateUrl);

            vm.submitEvent = submitEvent;
            vm.getElementSize = FormBuilderHelper.getElementSize;
            vm.getModel = getModel;
            vm.setModel = setModel;
            vm.determineDisabled = FormBuilderHelper.determineDisabled;
            vm.init = init;

            $element.html(template);
            var cloneElem = $compile($element.contents())($scope);

            $scope.$on('$destroy', function () {
                FormBuilderService.destroy(vm.formIdentifier);
                if (cloneElem != null) {
                    cloneElem.off();
                }
            });
        }

        function init() {
            vm.formIdentifier = vm.fbData.name;
            vm.elements = angular.copy(vm.fbData.elements);
            vm.buttons = angular.copy(vm.fbData.buttons);
            vm.buttonsWrapperType = vm.fbData.buttons_wrapper_type || 'grid';
            vm.renderedElements = {};
            vm.loaded = true;

            if (!vm.fbModel) {
                vm.model = angular.copy(lodash.get(vm.fbData, 'model', {}));
            } else {
                angular.merge(vm.fbModel, angular.copy(lodash.get(vm.fbData, 'model', {})));
                vm.model = vm.fbModel;
            }

            var fbMem = FormBuilderService.init(vm.formIdentifier, vm,$scope);
            fbMem.elementsService.syncRenderedElements(vm.renderedElements);
            if (lodash.has(vm.fbData, 'settings.hide_form_buttons')) {
                vm.hideButtons = vm.fbData.settings.hide_form_buttons;
            }

            if (!vm.hideButtons){
                if (lodash.isEmpty(vm.buttons)) {
                    vm.hideButtons = true;
                }
            }
        }



        function getModel() {
            return vm.model;
        }

        function setModel(model) {
            angular.merge(vm.model, model);
        }


        function submitEvent($event) {
            if (typeof vm.submit === typeof function() {}) {
                vm.submit();
            } else {
                $timeout(function () {
                    if (lodash.has(vm.fbData, 'events.submit')) {
                        var eventData = {
                            targetScope: {
                                name: vm.formIdentifier,
                                elements: vm.fbElements,
                                buttons: vm.fbButtons
                            },
                            target: $element,
                            event: $event,
                            model: vm.model,
                            formIdentifier: vm.formIdentifier
                        };

                        $scope.$emit(vm.fbData.events.submit, eventData);
                    }
                });
            }
        }
    }
})();